import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { useRouter } from "next/router";
import { useCallback, useEffect, useRef } from "react";
import Button from "@mui/material/Button";
import { useIsConnectionOk } from "@/hooks/utils/connection-check/useIsConnectionOk";
import { analysisEventKey, trackAnalysisEvent } from "@/utils/analysis/event";
import styles from "./styles.module.css";
export const NetworkError: React.FC = () => {
  const $ = _c(15);
  const router = useRouter();
  const prevConnectionOkRef = useRef(null);
  const {
    isConnectionOk
  } = useIsConnectionOk();
  let t0;
  if ($[0] !== router) {
    t0 = async () => {
      router.reload();
    };
    $[0] = router;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const reload = t0;
  let t1;
  let t2;
  if ($[2] !== isConnectionOk || $[3] !== router.pathname) {
    t1 = () => {
      if (prevConnectionOkRef.current === null) {
        prevConnectionOkRef.current = isConnectionOk;
        return;
      }
      if (!prevConnectionOkRef.current && isConnectionOk) {
        trackAnalysisEvent(analysisEventKey.CONNECTION_CHECK_RECOVERED, {
          pathname: router.pathname
        });
      }
      prevConnectionOkRef.current = isConnectionOk;
    };
    t2 = [isConnectionOk, router.pathname];
    $[2] = isConnectionOk;
    $[3] = router.pathname;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[6] !== isConnectionOk || $[7] !== reload) {
    t3 = () => {
      if (isConnectionOk) {
        reload();
      }
    };
    t4 = [isConnectionOk, reload];
    $[6] = isConnectionOk;
    $[7] = reload;
    $[8] = t3;
    $[9] = t4;
  } else {
    t3 = $[8];
    t4 = $[9];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Image height={100} width={100} src="/icon/noconnection.svg" alt="error-icon" />;
    t6 = <h3 className={styles.error_title}>ネットワークエラーが発生しました。</h3>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t5 = $[10];
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <p className={styles.error_description}>デバイスがネットワークに接続されていることを確認して、再度お試しください。<br />復旧しない場合はお手数ですが、再起動してください。</p>;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== reload) {
    t8 = <div className={styles.root}><div className={styles.notification_container}>{t5}{t6}{t7}<Button variant="contained" color="primary" className={styles.button} onClick={reload}>もう一度接続する</Button></div></div>;
    $[13] = reload;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};